<script setup>
defineProps({
  message: {
    type: String,
    required: true,
  },
  id: {
    type: String,
    required: true,
  },
  inverted: {
    type: Boolean,
    default: false,
  }
});
</script>
<template>
  <div class="form__error-message"
       :class="{'form__error-message--negative': inverted}"
       :id="id"
       aria-live="assertive">

    <span class="form__error-icon">
      <span class="icon">
        <svg xmlns="http://www.w3.org/2000/svg" width="34" height="34" fill="currentColor" viewBox="0 0 34 34" aria-labelledby="title-h28zfb9xa" role="img"><title id="title-h28zfb9xa">Fehlermeldung</title>
          <path fill-rule="evenodd" d="M17 8.2a8.8 8.8 0 1 0 0 17.6 8.8 8.8 0 0 0 0-17.6ZM6 17c0-6.075 4.925-11 11-11s11 4.925 11 11-4.925 11-11 11S6 23.075 6 17Zm11-6.05a1.1 1.1 0 0 1 1.1 1.1V17a1.1 1.1 0 0 1-2.2 0v-4.95a1.1 1.1 0 0 1 1.1-1.1Zm0 8.619a1.1 1.1 0 0 1 1.1 1.1v.043a1.1 1.1 0 0 1-2.2 0v-.043a1.1 1.1 0 0 1 1.1-1.1Z" clip-rule="evenodd"></path>
        </svg>
      </span>
    </span>
    <span class="form__error-text">
        {{ message }}
    </span>
  </div>
</template>